/**
 * Page 404 — route non trouvée.
 */

import { el, clear } from '../js/utils.js';
import { t } from '../js/i18n.js';
import { renderHeader } from '../components/header.js';
import { renderFooter } from '../components/footer.js';

export async function renderNotFound(root) {
  clear(root);

  const view = el(
    'main',
    { class: 'not-found container' },
    el('p', { class: 'eyebrow' }, t('notFound.eyebrow')),
    el('h1', {}, t('notFound.title')),
    el(
      'p',
      { class: 'muted', style: { marginTop: 'var(--space-3)' } },
      t('notFound.body')
    ),
    el(
      'a',
      { class: 'btn btn-ghost', href: '#/', style: { marginTop: 'var(--space-5)' } },
      t('notFound.back')
    )
  );

  root.append(renderHeader(), view, renderFooter());
}
